
var isAndroid =  (navigator.userAgent || '').match(/Android/i);
var mixin = require('../../common/mixin');
var getUA = require('../../common/get-ua');
var UA = getUA.internal();

function noop() {}

var channels = [
  'WECHAT_FRIENDS',
  'WECHAT_TIMELINE',
  'QQ',
  'SMS',
  'WEIBO',
  'QZONE',
  'EMAIL',
  'COPY',
  'PASSWORD'
]

var V2 = {
    'Copy': 1,
    'SMS': 2,
    'Email': 3,
    'Password': 4,
    'WeixinFriends': 10,
    'WeixinTimeline': 11,
    'QQ': 20,
    'Qzone': 21,
    'Weibo': 30,
    'Twitter': 10000,
    'Facebook': 10010,
    'Messenger': 10020,
    'Instagram': 10030,
    'Pinterest': 10040,
    'WhatsApp': 10050,
    'LINE': 10060
}

/*
 * MT 7.6 Android沿用MTNB渠道调用
 * MT 7.6 iOS使用titans 渠道分享
 * both of them are incorrect!!
 * */
function getChannel() {
    if(isAndroid){
        return {
            'WECHAT_FRIENDS': 128,
            'WECHAT_TIMELINE': 256,
            'QQ': 512,
            'SMS': 32,
            'WEIBO': 1,
            'QZONE': 2,
            // not supported
            'EMAIL': 0,
            'COPY': 0,
            V2: V2
        };
    } else {
        return {
            'WECHAT_FRIENDS': 0,
            'WECHAT_TIMELINE': 1,
            'QQ': 2,
            'SMS': 3,
            'WEIBO': 4,
            'QZONE': 5,
            'EMAIL': 6,
            'COPY': 7,
            V2: V2
        };
    }
}

function sum(array) {
    if (!array) return 0;
    var s = 0;
    for (var i = 0; i < array.length; i++) {
        s += array[i];
    }
    return s;
}

module.exports = {
    message: 'share',
    statics: getChannel(),
    mapper: function (ref) {
        var title = ref.title;
        var desc = ref.desc;
        var content = ref.content;
        var image = ref.image;
        var url = ref.url;
        var channel = ref.channel;
        var sceneToken = ref.sceneToken;
        var channelV2s = ref.channelV2s;
        var miniProgram = ref.miniProgram;
        var success = ref.success; if ( success === void 0 ) success = noop;
        var fail = ref.fail; if ( fail === void 0 ) fail = noop;
        var panel = ref.panel;
        var handle = ref.handle; if ( handle === void 0 ) handle = noop;

        var feed = channel !== undefined ? [].concat(channel) : 0
        // 如果只传入一个渠道，那么就直接分享出去
        // 将渠道常量作为八位二进制
        var feedBinary = this.util.parseFeed(feed);
        var appId = UA.appId;
        url = this.util.tidyUrlParams(url, appId);
        var originalSuccess = success;
        var originalFail = fail;
        
        var opt = {
            title: title,
            desc: desc,
            content: content,
            image: image,
            panel: panel,
            sceneToken: sceneToken,
            success: function(res){
              if(res.channel != undefined) {
                res.sharedTo = {};
                channels.forEach(function (ele, i) {res.sharedTo[ele] = (i === res.channel)});
              }
              if(res.channelV2 !== undefined) {
                res.sharedTo = res.sharedTo || {};
                Object.keys(V2).forEach(function (ele) {
                    res.sharedTo[ele] = res.sharedTo[ele] || res.channelV2 === V2.key;
                })
              }
              originalSuccess(res);
            },
            shareType: isAndroid ? sum(feed) : feedBinary,
            channelV2s: channelV2s,
            fail: function(res){
              if ( res === void 0 ) res = {};

              if(res.status === 'cancel' || res.errorMsg === 'unshare') {
                  res.isCancel = true;
              }
              originalFail(res);
            },
            url: this.util.tidyUrlParams(url),
            handle: handle,
        }
        if(!miniProgram) return opt;

        if(isAndroid){
            var miniProgramId = miniProgram.id;
            var miniProgramPath = miniProgram.path;
            var miniProgramImage = miniProgram.image;
            var miniProgramType = miniProgram.type;
            return mixin(opt,{miniProgramId: miniProgramId, miniProgramPath: miniProgramPath, miniProgramImage: miniProgramImage, miniProgramType: miniProgramType});
        } else {
            return mixin(opt,{miniProgram: miniProgram});
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/titans/api/share.js
// module id = 526
// module chunks = 0